export const SUPPORT_EMAIL = "support@oscar-radio.org";
